import { render, staticRenderFns } from "./RRuleModal.vue?vue&type=template&id=64ac22c5&scoped=true"
import script from "./RRuleModal.vue?vue&type=script&lang=js"
export * from "./RRuleModal.vue?vue&type=script&lang=js"
import style0 from "./RRuleModal.vue?vue&type=style&index=0&id=64ac22c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac22c5",
  null
  
)

export default component.exports